import { Navigate, useParams } from 'react-router-dom';
import { isLocale } from '../../messages';
import { LocalePage } from '../LocalePage';

export const LocaleRoute = () => {
  const { locale } = useParams<{ locale: string }>();
  if (!locale || !isLocale(locale)) return <Navigate to="/" replace />;
  return <LocalePage locale={locale} />;
};
